import { startOfMonth, endOfMonth } from 'date-fns';

export function getFirstEventOfMonth(month, events) {
    const monthStart = startOfMonth(month);
    const monthEnd = endOfMonth(month);

    const eventsInMonth = events.filter(event => {
        return event.performancedate >= monthStart && event.performancedate <= monthEnd;
    });

    if (eventsInMonth.length === 0) {
        return monthStart;
    }

    return eventsInMonth[0].performancedate;
}
